import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { AuthContext } from '../App';

export default function FollowingPage() {
  const { user } = useContext(AuthContext);
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    api.following()
      .then(setChannels)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [user]);

  if (!user) {
    return (
      <div className="page" style={{ textAlign: 'center', padding: '80px 24px' }}>
        <div style={{ fontSize: '3rem', marginBottom: '12px' }}>💜</div>
        <h2>Log in to see who you follow</h2>
        <button className="btn btn-primary" style={{ marginTop: '16px' }} onClick={() => navigate('/login')}>Log In</button>
      </div>
    );
  }

  const live = channels.filter(c => c.is_live);
  const offline = channels.filter(c => !c.is_live);

  return (
    <div className="page">
      <h1 style={{ fontSize: '1.8rem', fontWeight: 800, marginBottom: '24px' }}>Following</h1>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#adadb8' }}>Loading...</div>
      ) : channels.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#adadb8' }}>
          <div style={{ fontSize: '3rem', marginBottom: '12px' }}>💜</div>
          <h2>You're not following anyone yet</h2>
          <p style={{ marginTop: '8px' }}>Browse channels and follow your favorites!</p>
          <button className="btn btn-primary" style={{ marginTop: '16px' }} onClick={() => navigate('/')}>Browse</button>
        </div>
      ) : (
        <>
          {live.length > 0 && (
            <>
              <div className="section-title" style={{ color: '#eb0400' }}>Live Now ({live.length})</div>
              <div className="channel-grid" style={{ marginBottom: '32px' }}>
                {live.map(ch => (
                  <div key={ch.username} className="channel-card" onClick={() => navigate(`/${ch.username}/watch`)}>
                    <div className="channel-thumbnail">
                      <span className="offline-icon">🔴</span>
                      <span className="live-badge">LIVE</span>
                    </div>
                    <div className="channel-info">
                      <div className="channel-name">{ch.display_name || ch.username}</div>
                      <div className="channel-category">{ch.category}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {offline.length > 0 && (
            <>
              <div className="section-title" style={{ color: '#adadb8' }}>Offline ({offline.length})</div>
              <div className="channel-grid">
                {offline.map(ch => (
                  <div key={ch.username} className="channel-card" onClick={() => navigate(`/${ch.username}`)}>
                    <div className="channel-thumbnail">
                      <span className="offline-icon">📺</span>
                    </div>
                    <div className="channel-info">
                      <div className="channel-name">{ch.display_name || ch.username}</div>
                      <div className="channel-category">{ch.category}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
